import React from "react";

import { useHomeLocation } from "@/hooks/useHomeLocation";

import { TaskPanel } from "@/components/organisms";

/**
 * The task side panel, open when the URL names a task or the new-task
 * form. The panel itself (the lib's SidePanel, its header, its
 * dismissal) is TaskPanel's, through EditPanel.
 */
export const HomePanel: React.FC = () => {
	const { taskId, isNewTask } = useHomeLocation();
	if (!taskId && !isNewTask) return null;
	return <TaskPanel taskId={taskId} />;
};
